import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class RewardApplydetailsApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'reward-applydetails'
    }


 

}